import useTranslation from 'next-translate/useTranslation';
import ClassicModal from '.';

type Props = {
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  open?: boolean;
  loading?: boolean;
};

export default function ClassicLeaveModal(props: Props) {
  const { t } = useTranslation('ielts');
  return (
    <ClassicModal
      {...props}
      title={t('DoSpeaking.are_you_sure')}
      description={t('DoSpeaking.description_leave')}
      cancelText={t('DoSpeaking.end_the_test')}
      confirmText={t('DoSpeaking.stay_with_us')}
      loading={props.loading}
    />
  );
}
